module.exports = __webpack_public_path__ + "static/media/زيارة البحيرات في إنترلاكن.dc71e028.jpeg";